exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".accounts-4baa0dfd{display:flex;flex-direction:column}.arrows-91ac81b6{align-self:center}.preview-4a8d54e5{padding-bottom:20px;display:flex;align-items:center}.profileImg-8ee96c25{padding:20px}\n", ""]);

// Exports
exports.locals = {
	"accounts": "accounts-4baa0dfd",
	"arrows": "arrows-91ac81b6",
	"preview": "preview-4a8d54e5",
	"profileImg": "profileImg-8ee96c25"
};